import apiService from "./ApiService"
import { createQS } from "./Utils"

class MapaPublicoService {
  async cruzamentos(minLat, maxLat, minLng, maxLng) {
    try {
      const bbox = [minLat, minLng, maxLat, maxLng].join(',')
      const qs = createQS({ bbox })
      return await apiService.get(`mapa-publico/cruzamentos?${qs}`)
    } catch (ex) {
      throw ex
    }
  }

  async incluirOcorrencia(data) {
    try {
      return await apiService.post(`mapa-publico/ocorrencia`, data)
    } catch (ex) {
      throw ex
    }

  }

  async tipoProblema() {
    try {
      return await apiService.get(`mapa-publico/tipo-problema`)
    } catch (ex) {
      throw ex
    }
  }
}

const mapaPublicoService = new MapaPublicoService()
export default mapaPublicoService